// components/StatePill.js
export function StatePill({ state, className = '' }) {
  const full = stateFull(state);
  if (!full) return null;

  return (
    <span
      className={`ml-auto inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium bg-[#EEF2F7] text-[#111827] border border-[#E5E7EB] ${className}`}
      title={full}
    >
      {full}
    </span>
  );
}

// Normalize input (remove dots/spaces, uppercase) → map to full name
function stateFull(input) {
  const key = String(input || '').replace(/[^A-Za-z]/g, '').toUpperCase(); // "Ca." -> "CA", "NewYork" -> "NEWYORK"
  const abbr = NAME_TO_ABBR[key];
  return abbr ? ABBR_TO_FULL[abbr] : null;
}

// Minimal maps
const PAIRS = [
  ['AL','Alabama'], ['AK','Alaska'], ['AZ','Arizona'], ['AR','Arkansas'], ['CA','California'],
  ['CO','Colorado'], ['CT','Connecticut'], ['DE','Delaware'], ['FL','Florida'], ['GA','Georgia'],
  ['HI','Hawaii'], ['ID','Idaho'], ['IL','Illinois'], ['IN','Indiana'], ['IA','Iowa'],
  ['KS','Kansas'], ['KY','Kentucky'], ['LA','Louisiana'], ['ME','Maine'], ['MD','Maryland'],
  ['MA','Massachusetts'], ['MI','Michigan'], ['MN','Minnesota'], ['MS','Mississippi'], ['MO','Missouri'],
  ['MT','Montana'], ['NE','Nebraska'], ['NV','Nevada'], ['NH','New Hampshire'], ['NJ','New Jersey'],
  ['NM','New Mexico'], ['NY','New York'], ['NC','North Carolina'], ['ND','North Dakota'], ['OH','Ohio'],
  ['OK','Oklahoma'], ['OR','Oregon'], ['PA','Pennsylvania'], ['RI','Rhode Island'], ['SC','South Carolina'],
  ['SD','South Dakota'], ['TN','Tennessee'], ['TX','Texas'], ['UT','Utah'], ['VT','Vermont'],
  ['VA','Virginia'], ['WA','Washington'], ['WV','West Virginia'], ['WI','Wisconsin'], ['WY','Wyoming'],
  ['DC','District of Columbia']
];

const NAME_TO_ABBR = PAIRS.reduce((m,[abbr,name]) => {
  m[abbr] = abbr; // "CA" -> "CA"
  m[name.replace(/\s/g,'').toUpperCase()] = abbr; // "CALIFORNIA" -> "CA"
  return m;
}, {});

const ABBR_TO_FULL = PAIRS.reduce((m,[abbr,name]) => (m[abbr] = name, m), {});
